import {Component, h, Host, Prop} from '@stencil/core';

@Component({
  tag: 'nest-shell-header',
  styleUrl: 'nest-shell-header.scss',
  shadow: true,
})
export class NestShellHeader {
  @Prop() label: string;

  render() {
    return (
      <Host>
        <div class='nest-shell-header'>{this.label}</div>
      </Host>
    );
  }
}
